<ul id="tree-wrapper" *ngIf="treeData" [ngClass]="{'disableDiv': control}">
    <li id="tree-item" *ngFor="let node of treeData; let i = index;" [ngClass]="{'selected': selectedIndex === i}">
        <span *ngIf="node.children != 0 && node.children != undefined" (click)="toggleChild(node)" 
            style="padding: 4px;" [tabindex]="isActive ? 0 : -1" (keydown)="arrowPress($event, node)" role="button" 
            [attr.aria-label]="node.showChildren ? 'collapse' : 'expand, contains ' + node?.children?.length + ' items'">
            <b class="toggle">
                <span *ngIf=!node.showChildren><img width="6px" src="assets/brand/right_arrow.svg" /></span>
                <span *ngIf=node.showChildren> <img width="9px" src="assets/brand/down_arrow.svg" /></span>
            </b>
        </span>
        <span *ngIf="node.children == undefined">
            <img width="8px" />
        </span>
        <span id="tree-children" [tabindex]="isActive ? 0 : -1" (keydown)="labelPress($event, node)"
            [ngClass]="{'disableDiv': control, 'focus': selectedIndex === i && currentDepth == nodeDepth}"
            (click)="onSelectedItemClick(node);setRow(i)" (focus)="focusIn($event, node, i)" 
            [innerHTML]="node.label" (focusout)="focusOut()" role="button"></span>
        <app-tree *ngIf="node.showChildren" [isActive]="isActive" [treeData]="node.children"
            [(currentDepth)]="currentDepth" [(selectedIndex)]="selectedIndex" [nodeDepth]="nodeDepth + 1"
            (selected)="onSelectedItemClick($event)"></app-tree>
    </li>
</ul>